"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreditRangeInput = void 0;

var _react = require("react");

var _partialRight = _interopRequireDefault(require("ramda/src/partialRight"));

var _divide = _interopRequireDefault(require("ramda/src/divide"));

var _ifElse = _interopRequireDefault(require("ramda/src/ifElse"));

var _equals = _interopRequireDefault(require("ramda/src/equals"));

var _services = require("../../services/");

var _mocks = require("../../mocks");

var _sliderRangeValues = require("../../mocks/slider-range-values");

const DeviceTypes = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};
const SliderMinSize = {
  [DeviceTypes.MOBILE]: 43,
  [DeviceTypes.DESKTOP]: 75
};
const SliderThumbSize = {
  [DeviceTypes.MOBILE]: 40,
  [DeviceTypes.DESKTOP]: 48
};
const ContainerPaddingSize = {
  [DeviceTypes.MOBILE]: 40,
  [DeviceTypes.DESKTOP]: 96
};
const percentage = (0, _partialRight.default)(_divide.default, [100]);

const getSliderProgressStyle = (progress, currentPosition) => (0, _ifElse.default)((0, _equals.default)(100), () => '100%', () => `calc(${progress}% + ${currentPosition}px)`)(progress);

const calculateSliderProgress = (filled, deviceType) => {
  return SliderMinSize[deviceType] - filled * (percentage(SliderThumbSize[deviceType]) + percentage(ContainerPaddingSize[deviceType]));
};

const getSliderProgress = filled => {
  const mobileProgress = calculateSliderProgress(filled, DeviceTypes.MOBILE);
  const desktopProgress = calculateSliderProgress(filled, DeviceTypes.DESKTOP);
  return {
    mobile: getSliderProgressStyle(filled, mobileProgress),
    desktop: getSliderProgressStyle(filled, desktopProgress)
  };
};

const getDescription = value => {
  var _descriptionsByRange$;

  const {
    message
  } = (_descriptionsByRange$ = _mocks.descriptionsByRange.find(({
    min,
    max
  }) => value >= min && value <= max)) != null ? _descriptionsByRange$ : {};
  return message;
};

const getInitialIndexByValue = currentValue => {
  if (currentValue) {
    return _sliderRangeValues.SliderRangeValues.findIndex((0, _equals.default)(currentValue));
  }

  return 0;
};

const getInitialProgress = initialValue => {
  const index = getInitialIndexByValue(initialValue);
  const totalItems = _sliderRangeValues.SliderRangeValues.length - 1;
  const filled = index * 100 / totalItems;
  return getSliderProgress(filled);
};

const useCreditRangeInput = ({
  initialValue,
  onChange
}) => {
  const [sliderPosition, setSliderPosition] = (0, _react.useState)(getInitialIndexByValue(initialValue));
  const [sliderProgress, setSliderProgress] = (0, _react.useState)(getInitialProgress(initialValue));

  const getCreditValue = position => {
    return _sliderRangeValues.SliderRangeValues[Math.floor(position)];
  };

  const description = (0, _react.useMemo)(() => getDescription(getCreditValue(sliderPosition)), [getCreditValue(sliderPosition)]);

  const onSliderChange = ({
    value,
    filled
  }) => {
    setSliderPosition(Number(value));
    setSliderProgress(getSliderProgress(filled));
  };

  const onSliderBlur = ({
    target: {
      value
    }
  }) => {
    const creditValue = getCreditValue(value);
    (0, _services.dispatchInputValueChangeEvent)(creditValue);
  };

  (0, _react.useEffect)(() => {
    onChange(getCreditValue(sliderPosition));
  }, [sliderPosition]);
  return {
    sliderPosition,
    sliderProgress,
    description,
    onSliderChange,
    onSliderBlur,
    getCreditValue
  };
};

exports.useCreditRangeInput = useCreditRangeInput;